import React from 'react';
import { connect } from 'react-redux';
import { addExportConfig, updateExportConfig, destroyExportConfig } from 'services/exports/duck';


class ExportableCalloutWithBoxPlot extends React.PureComponent {
    constructor(props) {
        super(props);

        if (!props.exportName) {
            console.warn('ExportableCalloutWithBoxPlot: Missing exportName from callout with box plot'); // eslint-disable-line no-console
        }
    }

    componentDidMount() {
        if (this.props.exportName) {
            this.props.addExportConfig({
                exportName: this.props.exportName,
                type: 'callout-with-box-plot',
                title: this.props.title,
                value: this.props.value,
                boxPlot: this.props.boxPlot,
                seriesData: this.props.seriesData,
            });
        }
    }

    componentDidUpdate() {
        if (this.props.exportName) {
            this.props.updateExportConfig({
                exportName: this.props.exportName,
                type: 'callout-with-box-plot',
                title: this.props.title,
                value: this.props.value,
                boxPlot: this.props.boxPlot,
                seriesData: this.props.seriesData,
            });
        }
    }

    componentWillUnmount() {
        if (this.props.exportName) {
            this.props.destroyExportConfig({
                exportName: this.props.exportName
            });
        }
    }

    render() {
        return null;
    }
}


export default connect(null, {
    addExportConfig,
    updateExportConfig,
    destroyExportConfig
})(ExportableCalloutWithBoxPlot);



// WEBPACK FOOTER //
// ./src/containers/callouts/ExportableCalloutWithBoxPlot.js